export default {
	styleOverrides: {
		root: ({ theme }) => ({
			'& .MuiSelect-select.Mui-readOnly': {
				color: theme.palette.text.disabled,
				backgroundColor:
					theme.palette.components.input.outlined.eveCustom.disabledBG,
			},
			'& .MuiSelect-select.MuiOutlinedInput-input.Mui-disabled': {
				backgroundColor:
					theme.palette.components.input.outlined.eveCustom.disabledBG,
			},
			'& .MuiSelect-icon.Mui-disabled': {
				color: theme.palette.text.disabled,
			},
		}),
	},
};
